(function () {
    'use strict';

    angular.module("imApp").factory("paymentLangsService", [function () {
        let service = {};

        return service;
    }]);
})();
